var els = $('[data-location-field]');
if (els.length > 0) {
  require.ensure('../listings/location_field', function(require) {
    var LocationField = require('../listings/location_field');
    els.each(function() {
      return new LocationField(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/location_fields.initializer.js